/**
 * Thrown by `bootstrap()` only when `/v1/me` fails after a successful
 * token refresh — i.e., the user IS authenticated but the platform can't
 * serve the catalog. The shell surfaces this as an error overlay.
 *
 * Anonymous state (no session) is NOT thrown — `bootstrap()` resolves and
 * the shell's `user === null` branch renders LoginScreen.
 */
export class AuthBootstrapError extends Error {
    reason;
    cause;
    constructor(reason, message, cause) {
        super(message);
        this.name = 'AuthBootstrapError';
        this.reason = reason;
        this.cause = cause;
    }
}
//# sourceMappingURL=errors.js.map